var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "eye-slash",
    width: 60,
    height: 60,
    fill: "black",
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 15,
    y: 15,
    width: 30,
    height: 30,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17041 31.5L32.2954 4.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 28.575C14.9565 29.0296 16.4742 29.2573 18 29.25C24.15 29.355 30.39 25.035 34.23 20.79C34.6442 20.3344 34.8738 19.7408 34.8738 19.125C34.8738 18.5092 34.6442 17.9156 34.23 17.46C32.8415 15.9253 31.2983 14.538 29.625 13.32",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6352 10.905C23.2747 9.6804 20.6594 9.02785 18.0002 9.00002C12.0002 8.89502 5.70024 13.125 1.77024 17.46C1.356 17.9156 1.12646 18.5093 1.12646 19.125C1.12646 19.7408 1.356 20.3344 1.77024 20.79C3.90006 23.171 6.3965 25.1965 9.16524 26.79",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlashIcon);
export default __webpack_public_path__ + "static/media/eye-slash-icon.57b8a20e4ddf54bbd1599563b7cb099d.svg";
export { ForwardRef as ReactComponent };